// React
import { useEffect, useState } from "react"

// Utils
import { useApi } from "utils"
import { generateLinkTransaction } from "pages/Finance/Journal/utils/functions"

export function useLink(
  data_source: number,
  data_source_id: number
): string | null {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<string | null>(null)

  useEffect(() => {
    generateLinkTransaction({
      api,
      data_source,
      data_source_id
    }).then(setData)

    // eslint-disable-next-line
  }, [])

  return data
}